/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

#card-pre-intervention {
  .symptoms-list .MuiFormGroup-root {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .MuiFormControlLabel-root {
      width: 40%;
    }
  }
}
